import { render, staticRenderFns } from "./CollapseActionMenuItem.vue?vue&type=template&id=0e10e7a5&scoped=true"
import script from "./CollapseActionMenuItem.vue?vue&type=script&lang=js"
export * from "./CollapseActionMenuItem.vue?vue&type=script&lang=js"
import style0 from "./CollapseActionMenuItem.vue?vue&type=style&index=0&id=0e10e7a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e10e7a5",
  null
  
)

export default component.exports